// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1___14e7b0173af18b9f1e0","cls2":"RatingCard-cls2___69fc38693ddca16022d RatingCard-cls1___14e7b0173af18b9f1e0"};